export default __webpack_public_path__ + "static/media/3475.971b7503.png";